import { render, staticRenderFns } from "./Developer2.vue?vue&type=template&id=38780555"
import script from "./Developer2.vue?vue&type=script&lang=js"
export * from "./Developer2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports